import type { ReactNode } from 'react';
import { Text } from '@fluentui/react-components';
import { useSectionCardStyles } from './SectionCard.styles';

export interface SectionCardProps {
  title: string;
  icon: ReactNode;
  children: ReactNode;
  action?: ReactNode;
  testId?: string;
}

export const SectionCard = ({ title, icon, children, action, testId }: SectionCardProps) => {
  const styles = useSectionCardStyles();

  return (
    <section className={styles.root} data-testid={testId}>
      <div className={styles.header}>
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
        <Text as="h3" className={styles.title}>
          {title}
        </Text>
        {action && <span className={styles.headerAction}>{action}</span>}
      </div>
      <div className={styles.content}>{children}</div>
    </section>
  );
};

SectionCard.displayName = 'SectionCard';
